<ng-template swiperSlide>
  <ng-content />
</ng-template>
